<template>
  <div
    v-if="title || description"
    class="info"
  >
    <h2
      v-if="title"
      class="title"
    >
      {{ title }}
    </h2>
    <div
      v-if="description"
      class="subtitle"
    >
      {{ description }}
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    title?: string;
    description?: string;
  }>();
</script>

<style scoped lang="scss">
  .info {
    margin-top: 48px;

    @include tablet {
      margin-top: 40px;
    }
  }

  .title {
    @include base-800-750-extra;

    @include mobile {
      @include base-700-500-extra;
    }
  }

  .subtitle {
    max-width: 805px;
    margin-top: 16px;

    @include base-400-400-regular;
  }
</style>
